<div class="row">
    <div class="col-12 col-sm">
        <div class="filter_container">
            <div class="measurement-filter row">
                <div class="multi-select-dropdown col-lg-4 mb-3" #multiSelectDropDown>
                    <span class="measurement-header"> Measurements </span>
                    <div class="dropdown-input">
                       
                        <input type="text" placeholder="Pick Measurements" [(ngModel)]="searchText" (click)="toggleDropdown()"
                        (keyup)="filterOptions()" [style.width]="30" />
                        <div class="search-icon-svg" (click)="toggleDropdown()">
                        <i><img src="../../../../assets/images/search-icon.png" /></i>
        
                        </div>
                    </div>
                    <div class="dropdown-list" *ngIf="dropdownOpen">
                        <ng-container *ngFor="let option of filteredOptions">
                        <label>
                            <div class="dropdown-item">
                            <input type="checkbox" [checked]="isSelected(option)" (click)="toggleSelection(option)" />
                            <span class="item-text"> {{ option.value }}</span>
                            </div>
                        </label>
                        </ng-container>
                        <span class="no-measurements" *ngIf="filteredOptions.length === 0">No measurements found</span>
                    </div>
                    </div>
                    <div class=" col-lg-8">
                        <div class="measurement-board ">
                    <div class="measurement-board-text">
                        <span>Measurements </span>
                    </div>
                    <div class="measurement-board-options">
                        <ng-container class="Options-selected">
                        <div *ngIf="selectedOptions.length !== 0" class="selected-options">
                            <span *ngFor="let option of selectedOptions" class="selected-option">
                            {{ option.value }}
                            <span class="remove-option" (click)="removeSelection(option)">&#10005;</span>
                            </span>
                        </div>
                        </ng-container>
                        <ng-container *ngIf="selectedOptions.length === 0">
                        <div class="no-measurements-selected">
                            <span>No measurements selected</span>
                        </div>
                        </ng-container>
                        
                    </div>
                </div>
                    </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12 col-sm chartDiv">
        <div class="parent_chart">
            <div class="d-block chart-cover">
                <canvas 
                #chartElement 
                baseChart
                width="700" 
                height="600"
                [type]="'line'"
                [data]="graphData"
                [options]="graphOptions"
                [legend]="legends"
                >
                </canvas>
            </div>
        </div>
    </div>
    <div class="col-12 text-end">
        <k-button [type]="KButtonType.KLAiMSButton" [label]="'Save'" [color]="'brand-main'"
        (buttonClick)="saveChartParams()" class="btn_half" >
        </k-button>
    </div>
</div>
<div class="row">
    
</div>

<k-simple-alert [display]="displaySuccess" [msgType]="'success'" [message]="successText"
    [timeout]="timeout"></k-simple-alert>
<k-simple-alert [display]="displayError" [msgType]="'error'" [message]="errorText"
  [timeout]="timeout"></k-simple-alert>